import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/f04a87ce-a4ca-403b-8732-a8575a39437a",
        "alt": null
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use the stack component to distribute space and alignment between items in a vertical or horizontal direction (one-dimensional layout)`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{`. If you need both vertical and horizontal layout (two-dimensional layout), use the `}<a parentName="p" {...{
        "href": "/components/Grid"
      }}>{`grid`}</a>{` component instead. When in doubt, we recommend reading the `}<a parentName="p" {...{
        "href": "/components/Grid#grid-vs-stack"
      }}>{`grid vs stack`}</a>{` documentation.`}</p>
    <p>{`We recommend using the stack component for inline or text based elements. Stack enables items to scale, wrap, and shrink depending on each item's content and the available space.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/3cfb1fc3-071c-478e-8104-543dcc823927" alt="" />
    <Caption mdxType="Caption">
      Use the stack component for inline or text based elements. Like a
      navigational list or a button group.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/53436826-515f-49d6-b33c-d84124f29aa4" alt="" />
    <Caption mdxType="Caption">
      Don't use the stack component to create a grid of items. Use the grid
      component instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Gap`}</h3>
    <p>{`Use the gap to change the space between items. Use small values when grouping closed related items, and larger values to separate sections or non-related items between them.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/dd508033-0435-48af-9b0b-ab1881608d8e" alt="" />
    <Caption mdxType="Caption">
      Use large gap values to separate sections or non-related items.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/3e6974eb-2f80-4fee-9000-dc9fa31432a7" alt="" />
    <Caption mdxType="Caption">Don't use large gap values for related items.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Direction, alignment, and justification`}</h3>
    <p>{`Use the direction to control the rendering direction of items. The direction can be adjusted on different viewports. For example, an icon and a label might be rendered horizontally on large viewports, but vertically on small viewports for better readability and composition.`}</p>
    <p>{`Use the align and justify options for determining the rendering alignment on the cross-axis and main-axis respectively. Taking the example above, the icon and label might be aligned to the center on mobile viewports, but aligned to the start on large viewports.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/cd8eb55f-0f7e-40fd-bfdb-47ab8507370f" mdxType="CustomVideoPlayer" />
  <Caption mdxType="Caption">
    Use vertical layout on small viewports to ensure that the content is
    readable. Combine it with center alignment if the text is short and the
    context calls for it.
  </Caption>
    </div>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Grid"
        }}>{`Grid`}</a>{`: Use the grid component to create flexible and responsive grid-based layouts.`}</li>
    </ul>

    <div {...{
      "className": "footnotes"
    }}>
      <hr parentName="div"></hr>
      <ol parentName="div">
        <li parentName="ol" {...{
          "id": "fn-1"
        }}>{`The stack component is implemented using the `}<a parentName="li" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout"
          }}>{`CSS Flexbox Layout`}</a>{` specification.`}<a parentName="li" {...{
            "href": "#fnref-1",
            "className": "footnote-backref"
          }}>{`↩`}</a></li>
      </ol>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      